(() => {
  const COOKIE_DOMAIN = "; Domain=.getherpart.com; Path=/; SameSite=Lax; Secure";
  const PIXEL_ACCOUNT = "biz_zneYRK2BJJhmbD";
  let pageSent = false;
  let pixelStarted = false;

  function cookie(name) {
    const value = document.cookie
      .split("; ")
      .find((part) => part.startsWith(`${name}=`));
    return value ? decodeURIComponent(value.slice(name.length + 1)) : "";
  }

  function setCookie(name, value, seconds) {
    document.cookie = `${name}=${encodeURIComponent(value)}; Max-Age=${seconds}${COOKIE_DOMAIN}`;
  }

  function visitorId() {
    return cookie("_wuid") || (() => {
      try { return localStorage.getItem("_wuid") || ""; }
      catch { return ""; }
    })();
  }

  function send(name, detail = {}) {
    if (cookie("hp_analytics") !== "1" && cookie("hp_marketing") !== "1") return;
    const sessionId = cookie("hp_sid");
    if (!sessionId) return;
    const payload = {
      event_name: name,
      event_id: detail.event_id || crypto.randomUUID(),
      session_id: sessionId,
      url: location.href,
      landing_url: cookie("hp_landing") || location.href,
      visitor_id: visitorId(),
      detail,
    };
    const body = JSON.stringify(payload);
    if (navigator.sendBeacon) {
      navigator.sendBeacon("/api/funnel", new Blob([body], { type: "text/plain" }));
    } else {
      fetch("/api/funnel", {
        method: "POST", credentials: "same-origin", keepalive: true,
        headers: { "content-type": "text/plain" }, body,
      }).catch(() => {});
    }
  }

  function startPixel() {
    if (pixelStarted) return;
    pixelStarted = true;
    const script = document.createElement("script");
    script.async = true;
    script.src = "https://t.whop.tw/s.js";
    window.whop = window.whop || {
      q: [], t: Date.now(), s: [], o: "https://t.whop.tw",
      track(...args) { this.q.push([Date.now(), ...args]); },
      setScope(...args) {
        this.s = args.filter((value) => typeof value === "string");
        this.q.push([Date.now(), "setScope", ...this.s]);
      },
      scope(...scope) {
        return { track: (...args) => this.q.push([Date.now(), ...args, { __scope: scope }]) };
      },
    };
    window.whop.setScope(PIXEL_ACCOUNT);
    window.whop.track("page");
    document.head.appendChild(script);
  }

  function applyConsent() {
    const privacy = window.Shopify?.customerPrivacy;
    const analytics = privacy ? privacy.analyticsProcessingAllowed() : cookie("hp_analytics") !== "0";
    const marketing = privacy ? privacy.marketingAllowed() : cookie("hp_marketing") !== "0";
    setCookie("hp_analytics", analytics ? "1" : "0", 2592000);
    setCookie("hp_marketing", marketing ? "1" : "0", 2592000);
    if (!analytics && !marketing) {
      setCookie("hp_sid", "", 0);
      setCookie("hp_landing", "", 0);
      return;
    }
    if (!cookie("hp_sid")) {
      setCookie("hp_sid", crypto.randomUUID(), 1800);
      setCookie("hp_landing", location.href.slice(0, 3000), 1800);
    } else {
      setCookie("hp_sid", cookie("hp_sid"), 1800);
      if (!cookie("hp_landing")) setCookie("hp_landing", location.href.slice(0, 3000), 1800);
    }
    // Whop pixel is installed unconditionally in <head> by theme.liquid (Whop's Shopify install guide).
    if (!pageSent) {
      pageSent = true;
      setTimeout(() => send("store_page_view", {
        page_type: document.body.dataset.template || location.pathname,
      }), 300);
    }
  }

  window.hpTrack = send;
  document.addEventListener("QuizStart", () => send("quiz_started"));
  document.addEventListener("QuizComplete", () => send("quiz_completed"));
  document.addEventListener("click", (event) => {
    const link = event.target.closest?.("a[href]");
    if (!link || link.getAttribute("aria-disabled") === "true") return;
    let destination;
    try { destination = new URL(link.href); }
    catch { return; }
    const isCheckout = destination.hostname === "secure.getherpart.com" &&
      ["/ss", "/ot", "/kit"].includes(destination.pathname);
    const isStorefront = ["getherpart.com", "www.getherpart.com"].includes(destination.hostname) &&
      !destination.pathname.startsWith("/manage") &&
      !destination.pathname.startsWith("/account");
    if (!isCheckout && !isStorefront) return;
    new URLSearchParams(location.search).forEach((value, key) => {
      if (!destination.searchParams.has(key)) destination.searchParams.set(key, value);
    });
    if (!['coupon','coupon_code','promo','promo_code','discount','code'].some(key => destination.searchParams.has(key))) {
      const reward = cookie('hp_reward_coupon');
      if (reward === 'GOLD15') destination.searchParams.set('coupon', reward);
    }
    link.href = destination.toString();
    if (isCheckout) send("checkout_clicked", { plan: destination.pathname.slice(1) });
  }, true);
  document.addEventListener("visitorConsentCollected", applyConsent);
  if (window.Shopify?.loadFeatures) {
    window.Shopify.loadFeatures(
      [{ name: "consent-tracking-api", version: "0.1" }],
      () => { applyConsent(); },
    );
    setTimeout(applyConsent, 1500);
  } else applyConsent();
})();
